(function () {
  if (window.__preOrderModalBound) return;
  window.__preOrderModalBound = true;

  function getModal(form) {
    const modalId = form.getAttribute('data-pre-order-modal');
    return (modalId && document.getElementById(modalId)) || form.querySelector('.pre-order-modal');
  }

  function getFormFromModal(modal) {
    const formId = modal.getAttribute('data-product-form-id');
    if (formId) {
      const form = document.getElementById(formId);
      if (form) return form.closest('product-form');
    }
    return document.querySelector('product-form[data-pre-order="true"]');
  }

  function openModal(form) {
    const modal = getModal(form);
    if (!modal) return false;

    const productForm = form.querySelector('form');
    if (productForm) modal.setAttribute('data-product-form-id', productForm.id);
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    const agree = modal.querySelector('[data-pre-order-agree]');
    const error = modal.querySelector('[data-pre-order-error]');
    if (agree) agree.checked = false;
    if (error) error.hidden = true;

    form.dataset.preOrderConfirmed = 'false';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function shouldIntercept(form) {
    return form && form.dataset.preOrder === 'true' && form.dataset.preOrderConfirmed !== 'true';
  }

  document.addEventListener(
    'click',
    function (event) {
      const confirmBtn = event.target.closest('[data-pre-order-confirm]');
      if (confirmBtn) {
        event.preventDefault();
        const modal = confirmBtn.closest('.pre-order-modal');
        const agree = modal?.querySelector('[data-pre-order-agree]');
        const error = modal?.querySelector('[data-pre-order-error]');
        if (!agree?.checked) {
          if (error) error.hidden = false;
          agree?.focus();
          return;
        }
        if (error) error.hidden = true;
        const form = getFormFromModal(modal);
        closeModal(modal);
        if (!form) return;
        form.dataset.preOrderConfirmed = 'true';
        if ('preOrderConfirmed' in form) form.preOrderConfirmed = true;
        const nativeForm = form.querySelector('form');
        const submitButton = form.querySelector('[name="add"]');
        if (nativeForm?.requestSubmit) {
          nativeForm.requestSubmit(submitButton);
        } else {
          nativeForm?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
        return;
      }

      if (event.target.closest('[data-pre-order-close]')) {
        closeModal(event.target.closest('.pre-order-modal'));
        return;
      }

      if (event.target.classList.contains('pre-order-modal')) {
        closeModal(event.target);
        return;
      }

      const form = event.target.closest('product-form[data-pre-order="true"]');
      if (!shouldIntercept(form)) return;

      const addBtn = event.target.closest('[name="add"], .shopify-payment-button, shopify-accelerated-checkout');
      if (!addBtn) return;
      if (!getModal(form)) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(form);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target.closest('product-form[data-pre-order="true"]');
      if (!shouldIntercept(form)) return;
      event.preventDefault();
      event.stopPropagation();
      openModal(form);
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-pre-order-agree]')) return;
    if (!event.target.checked) return;
    const error = event.target.closest('.pre-order-modal')?.querySelector('[data-pre-order-error]');
    if (error) error.hidden = true;
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.pre-order-modal.is-open').forEach(closeModal);
  });
})();
